import { browserHistory } from "react-router";
import { delay, call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import * as apiDevice from "../../services/device/api_device";
import * as apiCommon from "../../services/apiCommon";
import * as sagaCommon from "../sagasCommon";
import { CLOSED } from "../../constants/constant_device_status";
import * as DocType from "../../constants/constant_doc_types";
import {
  DELETE_DEVICE,
  DELETE_DEVICE_FROM_LIST,
  FETCH_LIST_DEVICE,
  FETCH_DEVICE_BY_ID,
  SAVE_DEVICE
} from "../../constants/constant_saga_types";


export function* deleteDeviceSaga(feathersApp) {
  yield takeEvery(DELETE_DEVICE, callDeleteDevice, feathersApp);
}

export function* deleteDeviceFromListSaga(feathersApp) {
  yield takeEvery(
    DELETE_DEVICE_FROM_LIST,
    callDeleteDeviceFromList,
    feathersApp
  );
}

export function* fetchListDeviceSaga(feathersApp) {
  yield takeLatest(FETCH_LIST_DEVICE, callFetchListDevice, feathersApp);
}

export function* fetchDeviceForEditSaga(feathersApp) {
  yield takeEvery(FETCH_DEVICE_BY_ID, callFetchDeviceForEdit, feathersApp);
}

export function* saveDeviceSaga(feathersApp) {
  yield takeEvery(SAVE_DEVICE, callSaveDevice, feathersApp);
}

function* callDeleteDevice(feathersApp, action) {
  const result = yield deleteDevice(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push("/admin/device");
  }
}

function* deleteDevice(feathersApp, action) {
  try {
    const { id } = action;
    let result = null;
    if (!id) return result;

    yield sagaCommon.showProgressDeleteRecord();
    const state = yield select();
    const { tenant, user } = state;
    const params = { tenant, user, id };
    result = yield call(apiDevice.deleteDevice, feathersApp, params);
    yield sagaCommon.doneDeleteRecord(id, DocType.DEVICE);
    return result;
  } catch (error) {
    yield sagaCommon.showErrorDeleteRecord(error);
  }
}

function* callDeleteDeviceFromList(feathersApp, action) {
  yield deleteDevice(feathersApp, action);
  yield delay(2000);
  yield callFetchListDevice(feathersApp, { silent: true });
}

function* callFetchListDevice(feathersApp, action) {
  try {
    const { silent, filters } = action;
    yield sagaCommon.showProgressListTable(silent);
    const dataParams = {
      filters,
      list_type: DocType.DEVICE
    };
    const tableData = yield call(
      apiCommon.getDocs,
      feathersApp,
      dataParams
    );
    yield call(sagaCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total
    });
  } catch (error) {
    yield sagaCommon.showErrorListTable(error);
  }
}

function* callFetchDeviceForEdit(feathersApp, action) {
  const { id, silent } = action;
  try {
    yield sagaCommon.showProgressDataById(silent);
    if(id){
      const { tenant, user } = yield select();
      const fetchParams = { tenant, user, id };
      const data = yield call(
        apiDevice.fetchDeviceById,
        feathersApp,
        fetchParams
      );
      yield sagaCommon.doneDataById(data);
    } else{
      const data = { active: true, status: { _id: CLOSED } };
      yield sagaCommon.doneDataById(data);
    }    
  } catch (error) {
    yield sagaCommon.showErrorDataById(error, silent);
  }
}

function* callSaveDevice(feathersApp, action) {
  try {
    const { silent } = action;
    const { tenant, user } = yield select();
    yield sagaCommon.showProgressSaveRecord(silent);
    const result = yield call(apiDevice.saveDevice, feathersApp, {
      tenant,
      user,
      data: action.data
    });
    if (result && result.id) {
      yield put({ type: FETCH_DEVICE_BY_ID, id: result.id, silent: true });
      browserHistory.push(`/admin/device/edit/${result.id}`);
      yield sagaCommon.doneSaveRecord(result, "Device was saved");
    } else {
      yield sagaCommon.showErrorSaveRecord(new Error('Error in saving : Device'));
    }
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}
